import {Component, input, output} from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  standalone: true,
  imports: [],
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss'
})
export class ProgressBarComponent {
  // Input for total number of media items
  totalMediaItems = input<number>(1);

  // Input for current media index (0-based)
  currentIndex = input<number>(0);

  // Output for segment click events - emits the clicked index
  segmentClick = output<number>();

  // Check if we should show the progress bar (only for multiple items)
  shouldShow(): boolean {
    return this.totalMediaItems() > 1;
  }

  // Generate array for segments
  getSegments(): number[] {
    return Array.from({length: this.totalMediaItems()}, (_, i) => i);
  }

  // Check if a segment is the current one
  isCurrentSegment(index: number): boolean {
    return index === this.currentIndex();
  }

  onSegmentClick(event: MouseEvent, segmentIndex: number): void {
    // Prevent event bubbling and emit the segment index
    event.stopPropagation();
    this.segmentClick.emit(segmentIndex);
  }
}
